var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('section',{staticClass:"landing nopadding"},[_c('div',{staticClass:"top"}),_c('div',{staticClass:"bottom"}),_c('div',{staticClass:"btn",on:{"click":function($event){return _vm.gotogp()}}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }